var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueSolidLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 3,
    viewBox: "0 0 155 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 154.5,
    height: 3,
    rx: 1.5,
    fill: "#0E50FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSolidLine);
export default __webpack_public_path__ + "static/media/blue-solid-line.866faaed.svg";
export { ForwardRef as ReactComponent };